import { lazyLoad } from 'utils/loadable';

export const Appearance = lazyLoad(
  () => import('./index'),
  module => module.default,
);
